import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup as MuiRadioGroup } from '@mui/material'
import React, { useState } from 'react'
import { infoToastify } from '../../../util/toast';
import { useStatePtr } from '@pure-ptr/react';
import { RadioGroup, RadioGroupOption } from '../../../common';

export default function CopyClaimDialog({ openPtr, intl, selectedItemsPtr, claimsData, claimPageRecord, filter, significanceFlag,
    copyClaimToPreviewPending,copyOnlySelected=false,tableFiltersPtr=undefined,
    actions: { copyClaimToPreview, copyClaimToPreviewByCriteria } }) {

    const copyAllClaimsPtr = useStatePtr(false);
    
    const handleCopyClaimCallback = () => {
        selectedItemsPtr.set([]);
        openPtr.set(false);
        infoToastify(
            <>
                <b>Copy Claim(s) to Preview Client</b>
                <br />
                Your request is submitted. You’ll be notified once it is copied.
            </>,
        );
    }

    const selectedItems = selectedItemsPtr.value;

    const handleCopyClaimConfirmation = () => {
        if (selectedItems.length > 0) {

            if (copyAllClaimsPtr.value && selectedItems.length > 5) {
                let operandsWithoutBoth = (filter?.operands || [])?.filter(obj => 
                    !obj.filters.some(filter => filter.value === "both")
                );
                
                operandsWithoutBoth={operator:filter?.operator,operands:operandsWithoutBoth}
                const payload = {
                    filter:operandsWithoutBoth,
                }
                
                copyClaimToPreviewByCriteria(payload, significanceFlag, handleCopyClaimCallback);

            } else {
                const claims = claimsData.filter(claim => selectedItems.some(y => (y == claim.id || y == claim.claimnumber)));
                const payload = {
                    claimNumbers: claims.map(c => c.claimnumber)
                };
                
                copyClaimToPreview(payload, handleCopyClaimCallback)
            }
        }
    }

    return (
        (<div>
            <Dialog open={openPtr.value}>
                <DialogTitle>
                    {selectedItems?.length === 1 ? 'Copy Claim' : 'Copy Claims'}
                </DialogTitle>
                <DialogContent>
                    {selectedItems?.length > 0 ? (
                        (claimsData.length === selectedItems.length && !copyOnlySelected) ? <>
                            <RadioGroup 
                                valuePtr={copyAllClaimsPtr} 
                                label="Are you sure you want to copy"
                            >
                                <RadioGroupOption value={false}>
                                    {claimsData.length} selected claims
                                </RadioGroupOption>
                                <RadioGroupOption value={true}>
                                    All {claimPageRecord.totalRecords } claims
                                </RadioGroupOption>
                            </RadioGroup>
                        </> : <>
                            <DialogContentText>
                                {selectedItems.length === 1 
                                    ? 'Are you sure you want to copy this claim?' 
                                    : `Are you sure you want to copy ${selectedItems.length} claims?`}
                            </DialogContentText>
                        </>
                    ) :
                        'No claims selected, please select atleast one claim to copy'
                    }
                    
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => openPtr.set( false ) }>
                        {selectedItems?.length > 0 ? 'Cancel' : 'Close'}
                    </Button>
                    {selectedItems?.length > 0 && (
                        <Button
                            onClick={handleCopyClaimConfirmation}
                            disabled={copyClaimToPreviewPending}
                            color="primary"
                            variant='contained'
                        >
                            {'Copy Claim(s)'}
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>)
    );
}

